import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
export const concatUserAgents = (clientAgents) => {
    return clientAgents.concat(clientAgents.filter((agent) => agent));
};
/** Create a searchClient instance */
export function createSearchClient({ userAgent }) {
    return ({ url, apiKey, options = { clientAgents: [] }, }) => {
        const clientAgents = options.clientAgents || [];
        const { searchClient } = instantMeiliSearch(url, apiKey, {
            ...options,
            clientAgents: concatUserAgents([userAgent, ...clientAgents]),
        });
        return {
            ...searchClient,
        };
    };
}
//# sourceMappingURL=createSearchClient.js.map